import React from 'react';
import './NotFound.css'


const NotFound = () => {
    return (
        <div>
            <img src="https://i.stack.imgur.com/6M513.png" alt="" />
        </div>
    );
};

export default NotFound;